import { render } from "./AutocompleteDropdown.vue?vue&type=template&id=346d96c3&scoped=true&ts=true"
import script from "./AutocompleteDropdown.vue?vue&type=script&lang=ts"
export * from "./AutocompleteDropdown.vue?vue&type=script&lang=ts"

import "./autocomplete-input.scss?vue&type=style&index=0&id=346d96c3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346d96c3"]])

export default __exports__